import React, { useEffect, useState } from 'react';
import { Button, Form, message } from 'antd';
import Fragment from '../../../../components/fragment';
import { PlusOutlined } from '@ant-design/icons';
import { reqUpdateUser, reqRoles } from '../../../../api/index';

const ShowRole = ({ user }) => {
  const [data, setData] = useState([]);
  const onFinish = async (values) => {
    const result = await reqUpdateUser(user.email, values);
    if (result.status === 200) {
      message.success('更新成功');
    } else {
      message.error(result.error);
    }
  };
  const getRoles = async () => {
    const data = {
      verbose: '100',
      type: '1',
    };

    const result = await reqRoles(data);
    if (result.status === 200) {
      const roles = result.result;
      setData(roles);
    }
  };
  useEffect(() => {
    getRoles();
  }, []);

  const roleDesc = (role_id) => {
    if (role_id) {
      const item = data.find((item) => item.role_id === role_id);
      return item && item.desc;
    }
  };

  return (
    <Form name="dynamic_roles" onFinish={onFinish} style={{ margin: '20px' }}>
      {user.roles && (
        <Form.List name="roles" initialValue={user.roles}>
          {(fields, { add, remove }) => (
            <>
              {fields.map((field) => (
                <Fragment
                  field={field}
                  remove={remove}
                  role={roleDesc(user.roles[field.key])}
                  key={field.key}
                  roles={data}
                />
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  icon={<PlusOutlined />}>
                  增加角色
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      )}
      <Form.Item>
        <Button type="primary" htmlType="submit">
          保存
        </Button>
      </Form.Item>
    </Form>
  );
};
export default ShowRole;
